module.exports = __webpack_public_path__ + "img/video_border.5bdb60f8.jpg";